import type { Dayjs } from "dayjs";
import type { AssetRegisterAggregatedTimeSeriesResponse } from "kubb";
import type React from "react";
import AllPeriodReportTable from "../allPeriodReportTable/NewAllPeriodReportTable";

export const VOLUME_WEIGHTED_AVERAGE_AGGREGATIONS = [
  "volume_weighted_average",
  "volume_weighted_average_(domestic_hot_water)",
  "volume_weighted_average_(standby)",
  "volume_weighted_average_(space_heating)",
];

export const VOLUME_WEIGHTED_AVERAGE_AGGREGATION_NAMES = [
  {
    parameter: "Return Temperature",
    aggregation: "volume_weighted_average",
    name: "VWART",
  },
  {
    parameter: "Return Temperature",
    aggregation: "volume_weighted_average_(domestic_hot_water)",
    name: "VWART in Hot Water Mode",
  },
  {
    parameter: "Return Temperature",
    aggregation: "volume_weighted_average_(standby)",
    name: "VWART in Standby Mode",
  },
  {
    parameter: "Return Temperature",
    aggregation: "volume_weighted_(average_space_heating)",
    name: "VWART in Space Heating Mode",
  },
];

const VWARTReportView = (props: {
  scheme_id?: string;
  startDatetime: Dayjs;
  endDatetime: Dayjs;
  data?: AssetRegisterAggregatedTimeSeriesResponse;
}): React.ReactElement => {
  const { startDatetime, endDatetime } = props;

  return (
    <>
      {props.scheme_id && props.data && (
        <AllPeriodReportTable
          data={props.data}
          columnDefinitions={VOLUME_WEIGHTED_AVERAGE_AGGREGATION_NAMES}
          startDatetime={startDatetime}
          endDatetime={endDatetime}
          downloadFilename={`${props.scheme_id}_vwart_report`}
        />
      )}
    </>
  );
};

export default VWARTReportView;
